export const setForceSpeakerphoneOn = (on) => {};

export const start = (args) => {};

export const stop = (args) => {};

export const setKeepScreenOn = (on) => {};
